import QRCode from "qrcode";
import proxy from "api/proxy";

const styleSeparator =
  "border-top: 1px dashed; margin-top:0.5cm; margin-bottom:0.5cm";

function fmtLocalDate(value) {
  if (!value) return "";
  return new Date(`${value}T00:00:00`).toLocaleDateString("es-CO");
}

function getQrCode(url) {
  return QRCode.toString(url, { type: "svg" });
}

const generateInvoiceHTML = async (
  _sale,
  ctxPrinting,
  sale,
  record,
  htmlTax,
  infoTransferRoom,
  infoTransfer,
  imageLogo,
) => {
  const lines = sale?.lines || _sale["lines."];
  const entriesArray = Array.from(_sale["lines."].entries());

  const INVOICE_TYPE = {
    P: "SISTEMA POS:",
    1: "FACTURA DE VENTA ELECTRONICA:",
    M: "CORTESIA:",
    undefined: "CORTESIA:",
  };

  const logoDefault =
    "https://res.cloudinary.com/dl4sdiukx/image/upload/v1733183597/swyxqgd45ftno6qvlzui.png";
  console.log(record, "estos son los record");

  const title =
    record.kind === "reservation"
      ? "RESERVADO"
      : record.state !== "transferred"
        ? INVOICE_TYPE[sale?.invoice_type] ?? INVOICE_TYPE.undefined
        : "TRANSFERIDO";

  const number = _sale?.number ?? _sale?.order;
  const typeSystem = `<div>${title} <b style="display: block;">${number}</b></div>`;

  let activity = [];

  if (record.state === "transferred") {
    infoTransfer =
      "<div style='text-align:center; margin-top: 1.5cm; border-top: 1px dashed;margin-bottom: 0.5cm; padding-top: 0.1cm;'>Firma</div>";
    infoTransferRoom = `<div>${_sale.description}</div>`;

    _sale.party = record.party?.rec_name;
    _sale.party_id_number = record["party."]?.id_number;
    _sale.party_address = record["party."]?.address;
    _sale.party_phone = record["party."]?.mobile;
    _sale.payment_term = "Transferido";

    if (_sale.courtesy) {
      _sale.total_discount_amount = _sale["lines."].reduce((total, item) => {
        return total + item.base_price * item.quantity;
      }, 0);
    }
  }

  if (record.invoice_type !== "M") {
    const origins = record["lines."]
      .map((item) => item.origin?.id ?? null)
      .filter((id) => id !== null);

    if (origins.length > 0) {
      const { data } = await proxy.browse("sale_activity.activity", origins, [
        "id",
        "time_start",
        "time_end",
      ]);
      activity = data;
    }
  }

  const contenidoHTML = `
    <div style="width: 62mm; padding: 0.1cm; font-family: monospace; font-size: 2.8mm">
      <div style="text-align: center; margin-bottom: 0.5cm">
        <div style="margin-bottom: 0.5cm"><center><img src="${imageLogo || logoDefault}" width="60%"></center></div>
        <div>${ctxPrinting.company}</div>
        <div>${ctxPrinting.shop}</div>
        <div>NIT: ${ctxPrinting.id_number} ${ctxPrinting.regime_tax}</div>
        <div>${ctxPrinting.street}</div>
        <div>${ctxPrinting.city} Telefono: ${ctxPrinting.phone}</div>
      </div>
      ${typeSystem}
      <div>Fecha: ${fmtLocalDate(_sale.sale_date)}</div>
      <div style="${styleSeparator}"></div>
      <div>
        <div>Cliente: ${sale?.party ?? _sale["party."]?.rec_name}</div>
        ${infoTransferRoom ?? ""}
        ${_sale.description ? `<div>Nombre: ${_sale?.description}</div>` : ""}
        <div>ID: ${_sale?.party_id_number ?? _sale?.["party."]?.id_number}</div>
        <div>Direccion: ${sale?.party_address || _sale?.party_address || ""}</div>
        <div>Telefono: ${sale?.party_phone || _sale?.party_phone || _sale?.["party."]?.mobile}</div>
        <div>Forma de Pago: ${sale?.payment_term || _sale?.payment_term || "Cortesia"}</div>
      </div>
      ${await generateInvoiceLinesHTML(_sale, activity, sale, ctxPrinting, lines, entriesArray)}
      <div style="${styleSeparator}; border-top:1px dashed ; border-bottom:1px dashed; margin-top: 0.5cm; margin-bottom: 0.5cm;"></div>
      ${htmlTax || ""}
      ${infoTransfer || ""}
      <div style="text-align:center">Creado: ${_sale.create_date}</div>
      <div style="text-align:center">PROVEEDOR DEL SOFTWARE: PRESIK SAS</div>
      <div style="text-align:center">NIT: 900803782-2</div>
      <div style="text-align:center">SOFTWARE TRYTON - www.presik.com</div>
    </div>
  `;

  return contenidoHTML;
};

const generateInvoiceLinesHTML = async (
  _sale,
  _,
  sale,
  ctxPrinting,
  lines,
  entriesArray,
) => {
  const data = _sale ?? sale;
  const isTransferred = data?.state === "transferred";

  let imageQr = "";
  if (sale?.qr_code && !isTransferred) {
    imageQr = await getQrCode(sale.qr_code);
  }

  const taxes = sale?.taxes ?? {};
  let taxesHtml = `<div style="display: flex; justify-content: space-between;">
    <div>Tipo</div>
    <div>Base</div>
    <div>Imp.</div>
  </div>`;

  if (Object.keys(taxes).length > 0) {
    Object.values(taxes).forEach(({ name, base, tax }) => {
      taxesHtml += `
      <div style="display: flex; justify-content: space-between;">
        <div>${name}</div>
        <div>${parseInt(base || 0).toLocaleString("es-CO")}</div>
        <div>${parseInt(tax || 0).toLocaleString("es-CO")}</div>
      </div>`;
    });
  } else {
    taxesHtml += `<div style="text-align: center;">No hay impuestos</div>`;
  }

  return `
  <div style="margin-top: 0.3cm; margin-bottom: 0.1cm; display: flex; justify-content: space-between; border-top: 1px dashed; border-bottom: 1px dashed;">
    <div style="width: 60%;"><b>Articulo</b></div>
    <div style="width: 10%; text-align: center;"><b>Cant</b></div>
    <div style="width: 30%; text-align: right;"><b>Subtotal</b></div>
  </div>
  ${lines
    .map((item, index) => {
      console.log(item, "este es el item");

      if (item.parent) return "";
      const [, value] = entriesArray[index] ?? [];
      console.log(value, "value");

      const discount =
        item.discount_rate ??
        item?.additionals?.[0]?.discount ??
        item.discount ??
        null;

      const subtotal = !data.courtesy
        ? (() => {
            if (item.additionals?.length > 0) {
              return item.additionals
                .reduce(
                  (acc, add) => acc + Math.round(add.amount_w_tax || 0),
                  0,
                )
                .toLocaleString("es-CO");
            }
            return Math.round(
              (value?.base_price || 0) *
                (1 - (discount || 0)) *
                (item?.quantity || 1),
            ).toLocaleString("es-CO");
          })()
        : 0;

      return `
        <div style="display: flex; justify-content: space-between; margin-bottom: 0.1cm;">
          <div style="width: 60%;">${value?.description || item?.product?.name || item?.name} ${
            discount ? "DESC - " + discount * 100 + "%" : ""
          } </div>
          <div style="width: 10%; text-align: center;">${item?.quantity}</div>
          <div style="width: 30%; text-align: right;">${subtotal}</div>
        </div>`;
    })
    .join("")}

  <div style="display: flex; justify-content: space-between; margin-top: 0.3cm;">
    <div><b>Subtotal Base:</b></div>
    <div style="text-align: right;">${Math.round(data.untaxed_amount || 0).toLocaleString("es-CO")}</div>
  </div>
  <div style="display: flex; justify-content: space-between;">
    <div><b>Impuestos:</b></div>
    <div style="text-align: right;">${Math.round(data.tax_amount || 0).toLocaleString("es-CO")}</div>
  </div>
   <!--<div style="display: flex; justify-content: space-between;">
    <div><b>Descuento General:</b></div>
    <div style="text-align: right;">${data?.discount}</div>
  </div>-->
  ${
    data.paid_amount !== data.total_amount
      ? `<div style="display: flex; justify-content: space-between;">
          <div>
            <b>Anticipo:</b>
          </div>
          <div style="text-align: right;">
            <div style="border-top: 1px dashed; width: 20mm;"></div>
            ${Math.round(data.paid_amount || 0).toLocaleString("es-CO")}
          </div>
        </div>`
      : ""
  }
  <div style="display: flex; justify-content: space-between;margin-top: 0.3cm;">
    <div><b>Total:</b></div>
    <div style="text-align: right;">
      <div style="border-top: 1px dashed; width: 20mm; "></div>
      ${Math.round(data.total_amount || 0).toLocaleString("es-CO")}
    </div>
  </div>

   <div style="display: flex; justify-content: space-between; margin-bottom: 0.3cm;">
    <div><b>Fecha Reserva:</b></div>
    <div style="text-align: right;">
      <div style=""></div>
      ${fmtLocalDate(data.shipment_date || data.sale_date)}
    </div>
  </div>

  <div style="margin-top: 0.3cm; border-top: 1px dashed; border-bottom: 1px dashed;">
    <div><b>DETALLES DE IMPUESTOS</b></div>
    <div style="display: flex; flex-direction: column; gap: 0.2cm;">
      ${taxesHtml}
    </div>
  </div>

  ${
    !isTransferred && data?.payments?.length
      ? `<div style="margin-top: 0.3cm; border-top: 1px dashed; border-bottom: 1px dashed;">
          <div><b>MEDIOS DE PAGO</b></div>
          <div style="display: flex; flex-direction: column; gap: 0.2cm;">
            ${data.payments
              .map(
                (item) => `
              <div style="display: flex; justify-content: space-between;">
                <div> ${item.name} ${item?.voucher ? `(${item?.voucher})` : ""}</div>
                <div></div>
                <div>${Math.round(item.amount).toLocaleString("es-CO")}</div>
              </div>
            `,
              )
              .join("")}
          </div>
        </div>`
      : ""
  }

  <div style="display: flex; justify-content: space-between; margin-top: 0.3cm;">
    <div>No ITEMS:</div>
    <div>${sale?.lines?.filter((line) => !line.parent)?.length ?? 0}</div>
  </div>
  <div style="display: flex; justify-content: space-between;">
    <div>No PEDIDO:</div>
    <div>${data.order || _sale?.order}</div>
  </div>
  <div style="display: flex; justify-content: space-between;">
    <div>CAJA No.:</div>
    <div>${ctxPrinting.sale_device}</div>
  </div>
  <div style="display: flex; justify-content: space-between;">
    <div>VENDEDOR:</div>
    <div>${sale?.agent}</div>
  </div>

  <div style="${styleSeparator}; border-top:1px dashed ; border-botton:1px dashed; margin-top: 0.3cm; margin-bottom: 0.3cm;"></div>

  ${
    data.courtesy
      ? `<div style="display: flex; justify-content: space-between;">
        <div><b>Total Complimentary:</b></div>
        <div style="text-align: right;">${data.total_discount_amount}</div>
      </div>`
      : !isTransferred && !data.courtesy
        ? `<div style="margin-top: 0.3cm;">Autorizacion de facturacion ${
            ctxPrinting?.authorizations[sale?.invoice_type]?.kind
          } No ${ctxPrinting?.authorizations[sale?.invoice_type]?.number} del ${
            ctxPrinting?.authorizations[sale?.invoice_type]?.start_date_auth
          } hasta ${
            ctxPrinting?.authorizations[sale?.invoice_type]?.end_date_auth
          }, habilita desde ${ctxPrinting?.authorizations[sale?.invoice_type]?.prefix}${
            ctxPrinting?.authorizations[sale?.invoice_type]?.from_auth
          } a ${ctxPrinting?.authorizations[sale?.invoice_type]?.prefix}${
            ctxPrinting?.authorizations[sale?.invoice_type]?.to_auth
          }</div>
      <div style="max-width: 140px; margin: 0px 50;">${imageQr}</div>
      <div style="width:100%; word-wrap: break-word; margin-top: 0.2cm;">CUFE:${
        sale?.invoice_type === "1" ? data.cufe : ""
      }</div>`
        : ""
  }
  `;
};

export { generateInvoiceHTML };
